import React from 'react';

import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';

const Table = (props) => {
    return (
        <table className="table table-striped profiles-permission">
            <TableHeader productos={props.data.productos}
                categorias={props.data.categorias}
                programas={props.data.programas}
                filter={props.data.filter}
                selectProducto={props.selectProducto}
                selectCategoria={props.selectCategoria}
                selectPrograma={props.selectPrograma}
                buscarPerfil={props.buscarPerfil}/>
            <TableBody perfiles={props.data.perfiles}
                filter={props.data.filter}
                functions={props.data.functions}
                setPerfilEdicion={props.setPerfilEdicion}
                setInfoPerfilToDelete={props.setInfoPerfilToDelete} />
        </table>
    );
}

export default Table;